import styled from 'styled-components'
import maintenance from '@/assets/imges/maintenance/maintenance.png'
import { useEffect } from 'react'
import { setUpgradeStatus } from '@/redux/uploadSlice'
import { useDispatch } from 'react-redux'
import { t } from '@/i18n'
// import store from '@/redux'
const Maintenance = () => {
  const dispatch = useDispatch()
  // const start = sessionStorage.getItem('startTime')?.replace(/"/g, ' ')
  // const end = sessionStorage.getItem('endTime')?.replace(/"/g, ' ')
  useEffect(() => {
    dispatch(setUpgradeStatus({ status: 'waiting', type: '' }))
  }, [])

  return (
    <Content className="background-image">
      <img src={maintenance} style={{ height: '100vh', float: 'right' }} />
      <div className="desc">
        <div className="title">{t('您所访问的系统正在升级维护中')}</div>
        <div className="date">
          {/* 维护时间从<span className="time">{start || '本日'}</span>至
            <span className="time">{end || '次日'}</span> */}
        </div>
        <div className="footer">{t('请在非维护时段内进行访问')}</div>
      </div>
    </Content>
  )
}
export default Maintenance
const Content = styled.div`
  .background-image {
    position: relative;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .desc {
    position: absolute;
    top: 25%;
    left: 42px;
  }
  .title {
    /* width: 504px; */
    height: 36px;
    font-size: 36px;
    /* font-family: SourceHanSansCN-Medium, SourceHanSansCN; */
    font-weight: 500;
    color: #0c3a5f;
    line-height: 54px;
    margin-bottom: 32px;
  }
  .date {
    /* width: 351px; */
    /* height: 24px; */
    font-size: 24px;
    font-weight: 500;
    color: #0c3a5f;
    line-height: 36px;
    margin-bottom: 75px;
  }
  .time {
    color: #558492;
  }
  .footer {
    /* width: 336px; */
    height: 28px;
    font-size: 28px;
    /* font-family: SourceHanSansCN-Medium, SourceHanSansCN; */
    font-weight: 500;
    color: #666666;
    line-height: 42px;
  }
`
